import moment from "moment";
import { Card } from "react-bootstrap";
import { withTranslation } from "react-i18next";

function DetalleCitaHorario({t, cita}){


    return(
        <Card className="shadow-1">
            <Card.Body>
                <div className="d-flex justify-content-between">
                    <div>
                        <h6 className="mb-0">
                            Cita agendada
                        </h6> 
                    </div>
                    <div>
                        <h6 className="mb-0">
                            {
                                moment(cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMMM YYYY HH:mm")
                            }
                        </h6> 
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(DetalleCitaHorario)